import { render, staticRenderFns } from "./aIAssistant.vue?vue&type=template&id=62916082&scoped=true&"
import script from "./aIAssistant.vue?vue&type=script&lang=js&"
export * from "./aIAssistant.vue?vue&type=script&lang=js&"
import style0 from "./aIAssistant.vue?vue&type=style&index=0&id=62916082&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62916082",
  null
  
)

export default component.exports